module.exports = __webpack_public_path__ + "img/service-avatar.208f20f7.png";